import NetworkUtil from "./NetworkUtil";
import {CustomFieldType} from "../types/CustomFieldType";
import {ServerResponse} from "../types/ServerResponse";
import VaccineType from "../types/VaccineType";
import Banner from "../types/Banner";
import TestType from "../types/TestType";
import { PasswordConfigurationValues } from "../types/PasswordConfig";
import TreatmentType from "../types/TreatmentType";

export default class SystemAPI {

    public static async getBanner(id):Promise<{show:boolean, banner:Banner}>{
        return NetworkUtil.makePost("/api/system/banner", {id: id});
    }

    public static async getProductBrandingFromURL(url):Promise<{ProductID:number, Product:string, ProductLogoURL:string, ProductAltLogoURL:string, Name:string, ProductBackgroundImageURL:string, ProductButtonColorHexValue:string, ProductAdminNavLogoURL:string, ProductAdminNavBackgroundColorHexValue:string, ProductHelpEmail:string, reason?:string, success:boolean}>{
        return NetworkUtil.makePost("/api/system/logoURL", {currentURL:url});
    }

    public static async getBranding():Promise<{branding}>{
        return NetworkUtil.makeGet("/api/system/branding");
    }

    public static async getAllStates():Promise<{label:string, value:string}[]>{
        return NetworkUtil.makeGet("/api/system/states");
    }

    public static async getAllSchools():Promise<{schools:[], options:[]}>{
        return NetworkUtil.makeGet("/api/system/schools");
    }

    public static async getAllChildCareFacilities():Promise<{facilities:[]}>{
        return NetworkUtil.makeGet("/api/system/childcarefacilities");
    }

    public static async getFacilitySchools():Promise<{ID:number, FacilityName:string, SchoolDistrictID:number}[]>{
        return NetworkUtil.makeGet("/api/system/facility/schools");
    }

    public static async getFacilityChildcares():Promise<{ID:number, FacilityName:string}[]>{
        return NetworkUtil.makeGet("/api/system/facility/childcares");
    }


    public static async getAllSchoolDistricts():Promise<{label:string, value:string}[]>{
        return NetworkUtil.makeGet("/api/system/schooldistricts");
    }

    public static async getAllCountries():Promise<{label:string, value:string}[]>{
        return NetworkUtil.makeGet("/api/system/countries");
    }

    public static async getAllRaces():Promise<{label:string, value:number}[]>{
        return NetworkUtil.makeGet("/api/system/race");
    }

    public static async getAllInjectionSites(){
        return NetworkUtil.makeGet("/api/system/injectionsites");
    }

    public static async getAllImmunizations(){
        return NetworkUtil.makeGet("/api/system/immunizations");
    }

    public static async getAllTreatments():Promise<TreatmentType[]>{
        return NetworkUtil.makeGet("/api/system/treatments");
    }

    public static async getAllRelationships():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/system/allrelationships")
    }

    public static async getAllExemptionTypes():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/system/exemptionTypes")
    }

    public static async getAllPersonalExemptionReasons():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/system/personalExemptionReasons")
    }
   
    public static async getAllGenders():Promise<{label:string, value:number}[]>{
        return NetworkUtil.makeGet("/api/system/gender");
    }

    public static async getAllEthnicities():Promise<{label:string, value:number}[]>{
        return NetworkUtil.makeGet("/api/system/ethnicity");
    }

    public static async getAllSpecimenSources():Promise<{label:string, value:number}[]>{
        return NetworkUtil.makeGet("/api/system/specimensource");
    }

    public static async getAllSpecimenSourcesForTestingCheckin():Promise<{success:boolean, reason:string, data?:[]}>{
        return NetworkUtil.makeGet("/api/system/specimensourceForTestingCheckin");
    }

    public static async getAllTests():Promise<TestType[]>{
        return NetworkUtil.makeGet("/api/system/tests");
    }

    public static async getAllVaccines():Promise<VaccineType[]>{
        return NetworkUtil.makeGet("/api/system/vaccines");
    }

    public static async getConsentEntities():Promise<{ID:number,Name:string,FacilityID:number,AccessCode:string}[]>{
        return NetworkUtil.makeGet("/api/system/consentEntities");
    }

    public static async getAllPods(includeData:boolean=false):Promise<any>{
        return NetworkUtil.makePost("/api/admin/pods/filter", {includedata: includeData})
    }
    
    public static async getSpecimenLabels(body):Promise<{success:boolean, idList:any}>{
        return NetworkUtil.makePost("/api/admin/specimen", body)
    }
    
    public static async getCustomAppointmentQuestions():Promise<CustomQuestionsReponse>{
        return NetworkUtil.makeGet("/api/system/appointment/questions");
    }

    public static async getCustomQuestions(page):Promise<CustomQuestionsReponse>{
        return NetworkUtil.makePost("/api/system/appointment/questions?page="+page, {});
    }

    public static async getCustomQuestionsByID(id):Promise<CustomQuestionsReponse>{
        return NetworkUtil.makePost("/api/system/appointment/questions?id="+id, {});
    }

    public static async getPasswordRequirementConfig():Promise<{success:boolean,reason:string,data:PasswordConfigurationValues}>{
        return NetworkUtil.makeGet("/api/system/getPswdConfig");
    }

    public static async getAllResultTypes():Promise<{label:string, value:number, description:string}[]>{
        return NetworkUtil.makeGet("/api/system/resulttypes");
    }

    public static async getReportTypes():Promise<{label:string, value:number}[]>{
        return NetworkUtil.makeGet("/api/system/reportTypes");
    }

    public static async getAllCounties():Promise<{counties}>{
        return NetworkUtil.makeGet("/api/system/counties");
    }

}

interface CustomQuestionsReponse extends ServerResponse{
    questions:CustomFieldType[]
}